import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

const DashboardDefault = Loadable(lazy(() => import('views/frontend/dashboard')));
// ListStore
const ListStore = Loadable(lazy(() => import('views/frontend/stores/ListStore')));
const CreateStore = Loadable(lazy(() => import('views/frontend/stores/CreateStore')));
const UpdateStore = Loadable(lazy(() => import('views/frontend/stores/UpdateStore')));
const ViewStore = Loadable(lazy(() => import('views/frontend/stores/ViewStore')));
// Department
const ListDept = Loadable(lazy(() => import('views/frontend/depts/ListDept')));
const CreateDept = Loadable(lazy(() => import('views/frontend/depts/CreateDept')));
const UpdateDept = Loadable(lazy(() => import('views/frontend/depts/UpdateDept')));
const ViewDept = Loadable(lazy(() => import('views/frontend/depts/ViewDept')));
// User
const ListUser = Loadable(lazy(() => import('views/frontend/users/ListUser')));
const CreateUser = Loadable(lazy(() => import('views/frontend/users/CreateUser')));
const UpdateUser = Loadable(lazy(() => import('views/frontend/users/UpdateUser')));
const ViewUser = Loadable(lazy(() => import('views/frontend/users/ViewUser')));
// shippers
const ListShipper = Loadable(lazy(() => import('views/frontend/shippers/ListUser')));
const CreateShipper = Loadable(lazy(() => import('views/frontend/shippers/CreateUser')));
const UpdateShipper = Loadable(lazy(() => import('views/frontend/shippers/UpdateUser')));
const ViewShipper = Loadable(lazy(() => import('views/frontend/shippers/ViewUser')));

// Complaint
const ListComplaint = Loadable(lazy(() => import('views/frontend/complaints/ListComplaint')));
const CreateComplaint = Loadable(lazy(() => import('views/frontend/complaints/CreateComplaint')));
const UpdateComplaint = Loadable(lazy(() => import('views/frontend/complaints/UpdateComplaint')));
const ViewComplaint = Loadable(lazy(() => import('views/frontend/complaints/ViewComplaint')));
const BoardComplaint = Loadable(lazy(() => import('views/frontend/complaints/Board')));
// report
const ReportByYear = Loadable(lazy(() => import('views/frontend/report/ReportYear')));
const ReportByMonth = Loadable(lazy(() => import('views/frontend/report/ReportMonth')));
const ReportDept = Loadable(lazy(() => import('views/frontend/report/ReportDept')));
const ReportStore = Loadable(lazy(() => import('views/frontend/report/ReportStore')));
const ReportSolution = Loadable(lazy(() => import('views/frontend/report/ReportSolution')));

// Setting
const ListRole = Loadable(lazy(() => import('views/frontend/roles/ListRole')));
const ListRoleOfUser = Loadable(lazy(() => import('views/frontend/roles/ListRoleOfUser')));
const UpdateRole = Loadable(lazy(() => import('views/frontend/roles/UpdateRole')));
const ProfileSetting = Loadable(lazy(() => import('views/frontend/profiles')));

// Member register
const ListMemberRegister = Loadable(lazy(() => import('views/frontend/member_register/List')));
const MemberRegisterView = Loadable(lazy(() => import('views/frontend/member_register/View')));

// VAT in4
const ListVATInfo = Loadable(lazy(() => import('views/frontend/vat_info/List')));
const VATInfoView = Loadable(lazy(() => import('views/frontend/vat_info/View')));
const VATInfoCreate = Loadable(lazy(() => import('views/frontend/vat_info/Create')));
const VATInfoUpdate = Loadable(lazy(() => import('views/frontend/vat_info/Update')));

const ListVATGetInfo = Loadable(lazy(() => import('views/frontend/vat_get_info/List')));

// Goods Refund
const ListGoodsRefund = Loadable(lazy(() => import('views/frontend/goods_refund/List')));
// Goods Delivery
const ListGoodsDelivery = Loadable(lazy(() => import('views/frontend/goods_delivery/List')));
const CreateGoodsDelivery = Loadable(lazy(() => import('views/frontend/goods_delivery/Create')));
const UpdateGoodsDelivery = Loadable(lazy(() => import('views/frontend/goods_delivery/Update')));
const ViewGoodsDelivery = Loadable(lazy(() => import('views/frontend/goods_delivery/View')));
// Supplier Staff
const ListSupplierStaff = Loadable(lazy(() => import('views/frontend/supplier_staffs/List')));
const CreateSupplierStaff = Loadable(lazy(() => import('views/frontend/supplier_staffs/Create')));
const UpdateSupplierStaff = Loadable(lazy(() => import('views/frontend/supplier_staffs/Update')));
const ViewSupplierStaff = Loadable(lazy(() => import('views/frontend/supplier_staffs/View')));
// Supplier Staff Checking
const ListSupplierStaffCheckin = Loadable(lazy(() => import('views/frontend/supplier_staffs_checking/List')));
const StatisticsSupplierStaffCheckin = Loadable(lazy(() => import('views/frontend/supplier_staffs_checking/Statistics')));
// Product promotion
const ListProductPromotion = Loadable(lazy(() => import('views/frontend/product_promotion/List')));
const CreateProductPromotion = Loadable(lazy(() => import('views/frontend/product_promotion/Create')));
const ListProductPromotionHistory = Loadable(lazy(() => import('views/frontend/product_promotion_history/List')));
const ListSumReportProductPromotionHistory = Loadable(lazy(() => import('views/frontend/product_promotion_history/ListSumReport')));
const ListSumReportProductPromotionStatistics = Loadable(lazy(() => import('views/frontend/product_promotion_history/Statistics')));
// Master company
const ListMasterCompany = Loadable(lazy(() => import('views/frontend/master_company/List')));
// const CreateMasterCompany = Loadable(lazy(() => import('views/frontend/master_company/Create')));
const UpdateMasterCompany = Loadable(lazy(() => import('views/frontend/master_company/Update')));
const ListPriceChecking = Loadable(lazy(() => import('views/frontend/price_checking/List')));
// const CreateMasterCompany = Loadable(lazy(() => import('views/frontend/master_company/Create')));
const UpdatePriceChecking = Loadable(lazy(() => import('views/frontend/price_checking/Update')));

// Task management
const ListTask = Loadable(lazy(() => import('views/frontend/tasks/List')));
const StatisticsTask = Loadable(lazy(() => import('views/frontend/tasks/Statistics')));
const TaskCheckList = Loadable(lazy(() => import('views/frontend/tasks/TaskCheckList')));
// const CreateTask = Loadable(lazy(() => import('views/frontend/product_promotion/Create')));
// Mail
const Mail = Loadable(lazy(() => import('views/frontend/mail')));

const ListModules = Loadable(lazy(() => import('views/frontend/modules/List')));
// revenue_forecast
const RevenueForecastList = Loadable(lazy(() => import('views/frontend/revenue_forecast/List')));

const ListGiftCardEvents = Loadable(lazy(() => import('views/frontend/gift_card_events/List')));
const ListGiftCardEventlogs = Loadable(lazy(() => import('views/frontend/gift-card-event-logs/List')));
const StatisticsGiftCardEventlogs = Loadable(lazy(() => import('views/frontend/gift-card-event-logs/Statistics')));

const ListCustomerSurveyResponses = Loadable(lazy(() => import('views/frontend/customer-survey-responses/List')));
const ViewCustomerSurveyResponses = Loadable(lazy(() => import('views/frontend/customer-survey-responses/View')));

const CreateGiftCardEvents = Loadable(lazy(() => import('views/frontend/gift_card_events/Create')));
const ListGiftCardEventProducts = Loadable(lazy(() => import('views/frontend/gift-card-event-products/List')));
const CreateGiftCardEventProducts = Loadable(lazy(() => import('views/frontend/gift-card-event-products/Create')));


const ListEvents = Loadable(lazy(() => import('views/frontend/events/List')));
const CreateEvents = Loadable(lazy(() => import('views/frontend/events/Create')));
const UpdateEvents = Loadable(lazy(() => import('views/frontend/events/Create')));
const ListEventProducts = Loadable(lazy(() => import('views/frontend/event_products/List')));
const UpdateProductEvents = Loadable(lazy(() => import('views/frontend/event_products/Create')));
const ListEventLogs = Loadable(lazy(() => import('views/frontend/gift-card-event-logs/List')));
// const CreateGiftCardEvents = Loadable(lazy(() => import('views/frontend/gift_card_events/Create')));
// Emartmall
const OrderList = Loadable(lazy(() => import('views/frontend/emartmall/orders/List')));
const GetFailedOrder = Loadable(lazy(() => import('views/frontend/emartmall/orders/GetFailedOrder')));
const ScanDeliverySuccess = Loadable(lazy(() => import('views/frontend/orders/ScanDeliverySuccess')));

const MaintenanceError = Loadable(lazy(() => import('views/pages/maintenance/Error')));
// ==============================|| MAIN ROUTING ||============================== //

const SystemRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        /* ---------------------------------- Email --------------------------------- */
        {
            path: '/mail',
            element: <Mail />
        },
        /* ---------------------------------- Dashb --------------------------------- */
        {
            path: '/dashboard',
            element: <DashboardDefault />
        },
        /* ---------------------------------- Store --------------------------------- */
        {
            path: '/stores',
            element: <ListStore />
        },
        {
            path: '/stores/create',
            element: <CreateStore />
        },
        {
            path: '/stores/update/:id',
            element: <UpdateStore />
        },
        {
            path: '/stores/view/:id',
            element: <ViewStore />
        },
        /* ---------------------------------- Dept ---------------------------------- */
        {
            path: '/departments',
            element: <ListDept />
        },
        {
            path: '/departments/create',
            element: <CreateDept />
        },
        {
            path: '/departments/update/:id',
            element: <UpdateDept />
        },
        {
            path: '/departments/view/:id',
            element: <ViewDept />
        },
        /* ---------------------------------- User ---------------------------------- */
        {
            path: '/users',
            element: <ListUser />
        },
        {
            path: '/users/create',
            element: <CreateUser />
        },
        {
            path: '/users/update/:id',
            element: <UpdateUser />
        },
        {
            path: '/users/view/:id',
            element: <ViewUser />
        },
        /* ---------------------------------- ListShipper ---------------------------------- */
        {
            path: '/shippers',
            element: <ListShipper />
        },
        {
            path: '/shippers/create',
            element: <CreateShipper />
        },
        {
            path: '/shippers/update/:id',
            element: <UpdateShipper />
        },
        {
            path: '/shippers/view/:id',
            element: <ViewShipper />
        },
        /* -------------------------------- Complaint ------------------------------- */
        {
            path: '/complaints',
            element: <ListComplaint />
        },
        {
            path: '/complaints/new',
            element: <ListComplaint />
        },
        {
            path: '/complaints/processing',
            element: <ListComplaint />
        },
        {
            path: '/complaints/completed',
            element: <ListComplaint />
        },
        {
            path: '/complaints/closed',
            element: <ListComplaint />
        },
        {
            path: '/complaints/overdue',
            element: <ListComplaint />
        },
        {
            path: '/complaints/trashed',
            element: <ListComplaint />
        },
        {
            path: '/complaints/reopen',
            element: <ListComplaint />
        },
        {
            path: '/complaints/create',
            element: <CreateComplaint />
        },
        {
            path: '/complaints/update/:id',
            element: <UpdateComplaint />
        },
        {
            path: '/complaints/view/:id',
            element: <ViewComplaint />
        },
        {
            path: '/complaints/board',
            element: <BoardComplaint />
        },
        /* --------------------------------- Report --------------------------------- */
        {
            path: '/report/by-year',
            element: <ReportByYear />
        },
        {
            path: '/report/by-month',
            element: <ReportByMonth />
        },
        {
            path: '/report/by-department',
            element: <ReportDept />
        },
        {
            path: '/report/by-stores',
            element: <ReportStore />
        },
        {
            path: '/report/by-tag',
            element: <ReportByMonth />
        },
        {
            path: '/report/by-solution',
            element: <ReportSolution />
        },
        /* --------------------------------- Setting -------------------------------- */
        {
            path: '/user-roles',
            element: <ListRole />
        },
        {
            path: '/user-roles/:id',
            element: <ListRoleOfUser />
        },
        {
            path: '/user-roles/update/:id',
            element: <UpdateRole />
        },
        {
            path: '/profile-setting',
            element: <ProfileSetting />
        },
        /* ---------------------------- Member registion ---------------------------- */
        {
            path: '/member-register',
            element: <ListMemberRegister />
        },
        // {
        //     path: '/member-register/create',
        //     element: <MemberRegister />
        // },
        // {
        //     path: '/member-register/update/:id',
        //     element: <UpdateUser />
        // },
        {
            path: '/member-register/view/:id',
            element: <MemberRegisterView />
        },
        /* -------------------------------- VAT INFO -------------------------------- */
        {
            path: '/vat-info',
            element: <ListVATInfo />
        },
        {
            path: '/vat-info/create',
            element: <VATInfoCreate />
        },
        {
            path: '/vat-info/update/:id',
            element: <VATInfoUpdate />
        },
        {
            path: '/vat-info/view/:id',
            element: <VATInfoView />
        },
        /* -------------------------------------------------------------------------- */
        /*                                 VAT GET IN4                                */
        /* -------------------------------------------------------------------------- */
        {
            path: '/vat-get-info',
            element: <ListVATGetInfo />
        },
        /* ------------------------------ Goods refund ------------------------------ */
        {
            path: '/goods-refund',
            element: <ListGoodsRefund />
        },
        // {
        //     path: '/vat-info/update/:id',
        //     element: <UpdateUser />
        // },
        // {
        //     path: '/vat-info/view/:id',
        //     element: <VATInfoView />
        // },
        /* ----------------------------- Goods Delivery ----------------------------- */
        {
            path: '/goods-delivery',
            element: <ListGoodsDelivery />
        },
        {
            path: '/goods-delivery/create',
            element: <CreateGoodsDelivery />
        },
        {
            path: '/goods-delivery/update/:id',
            element: <UpdateGoodsDelivery />
        },
        {
            path: '/goods-delivery/view/:id',
            element: <ViewGoodsDelivery />
        },
        {
            path: '/goods-delivery/print/:id',
            element: <ViewGoodsDelivery />
        },
        /* ----------------------------- Supplier Staff ----------------------------- */
        {
            path: '/supplier-staffs',
            element: <ListSupplierStaff />
        },
        {
            path: '/supplier-staffs/create',
            element: <CreateSupplierStaff />
        },
        {
            path: '/supplier-staffs/update/:id',
            element: <UpdateSupplierStaff />
        },
        {
            path: '/supplier-staffs/view/:id',
            element: <ViewSupplierStaff />
        },
        {
            path: '/supplier-staffs-checkin',
            element: <ListSupplierStaffCheckin />
        },
        {
            path: '/supplier-staffs-statistics',
            element: <StatisticsSupplierStaffCheckin />
        },
        {
            path: '/product-promotions',
            element: <ListProductPromotion />
        },
        {
            path: '/product-promotions/create',
            element: <CreateProductPromotion />
        },
        {
            path: '/product-promotions-history',
            element: <ListProductPromotionHistory />
        },
        {
            path: '/product-promotions-sum-report',
            element: <ListSumReportProductPromotionHistory />
        },
        {
            path: '/product-promotions-statistics',
            element: <ListSumReportProductPromotionStatistics />
        },
        {
            path: '/product-promotions/update/:id',
            element: <CreateProductPromotion />
        },
        {
            path: '/task-management',
            element: <ListTask />
        },
        {
            path: '/task-statistics',
            element: <StatisticsTask />
        },
        {
            path: '/task-management/create',
            element: <CreateProductPromotion />
        },
        {
            path: '/task-management/update/:id',
            element: <CreateProductPromotion />
        },
        {
            path: '/task-management/:id/checklist',
            element: <TaskCheckList />
        },
        {
            path: '/master-company',
            element: <ListMasterCompany />
        },
        {
            path: '/master-company/create',
            element: <UpdateMasterCompany />
        },
        {
            path: '/master-company/update/:id',
            element: <UpdateMasterCompany />
        },
        {
            path: '/price-checking',
            element: <ListPriceChecking />
        },
        {
            path: '/price-checking/create',
            element: <UpdatePriceChecking />
        },
        {
            path: '/price-checking/update/:id',
            element: <UpdatePriceChecking />
        },
        {
            path: '/modules',
            element: <ListModules />
        },
        {
            path: '/revenue-forecast',
            element: <RevenueForecastList />
        },
        {
            path: '/orders',
            element: <OrderList />
        },
        {
            path: '/scan-order-success',
            element: <ScanDeliverySuccess />
        },
        {
            path: '/my-orders',
            element: <ScanDeliverySuccess />
        },
        {
            path: '/orders/get-failed-order',
            element: <GetFailedOrder />
        },
        {
            path: '/gift-card-events',
            element: <ListGiftCardEvents />
        },
        {
            path: '/gift-card-events/create',
            element: <CreateGiftCardEvents />
        },
        {
            path: '/gift-card-events/update/:id',
            element: <CreateGiftCardEvents />
        },
        {
            path: '/gift-card-event-products',
            element: <ListGiftCardEventProducts />
        },
        {
            path: '/gift-card-event-products/create',
            element: <CreateGiftCardEventProducts />
        },
        {
            path: '/gift-card-event-products/update/:id',
            element: <CreateGiftCardEventProducts />
        },
        {
            path: '/gift-card-event-logs',
            element: <ListGiftCardEventlogs />
        },
        {
            path: '/gift-card-event-statistics',
            element: <StatisticsGiftCardEventlogs />
        },
        {
            path: '/customer-survey-responses',
            element: <ListCustomerSurveyResponses />
        },
        {
            path: '/customer-survey-responses/update/:id',
            element: <ViewCustomerSurveyResponses />
        },
        {
            path: '/events',
            element: <ListEvents />
        },
        {
            path: '/events/create',
            element: <CreateEvents />
        },
        {
            path: '/events/update/:id',
            element: <UpdateEvents />
        },
        {
            path: '/event-products',
            element: <ListEventProducts />
        },
        {
            path: '/event-products/update/:id',
            element: <UpdateProductEvents />
        },
        {
            path: '/event-logs',
            element: <ListEventLogs />
        },
        /* -------------------------------- Not Found ------------------------------- */
        {
            path: '/not-found',
            element: <MaintenanceError />
        },
    ]
};

export default SystemRoutes;
